// @context TGW-2581 イベント詳細MVスライダーの「写真の末尾に動画」「タップで次へ（最後は先頭へ）」を固定する。
import React from 'react';
import ReactDOM from 'react-dom';
import { act } from 'react-dom/test-utils';
import MainSlider from './main_slider';
import { totalSlidesCount, nextIndexOnTap, isTap } from './main_slider_logic';

jest.mock('../event/youtube_video', () => () => null);

describe('totalSlidesCount', () => {
  it('サークル動画2本なら 1 + YouTube + サブ写真 + 2', () => {
    expect(
      totalSlidesCount({ videoIds: ['a'], subPhotoUrls: ['s1', 's2'], circleMovieUrls: ['m1', 'm2'] }),
    ).toBe(1 + 1 + 2 + 2);
  });

  it('circleMovieUrls 省略時は従来どおり', () => {
    expect(totalSlidesCount({ videoIds: [], subPhotoUrls: ['s1'] })).toBe(2);
  });
});

describe('nextIndexOnTap', () => {
  it('途中のスライドでは +1', () => {
    expect(nextIndexOnTap(1, 4)).toBe(2);
  });

  it('最後のスライドでは先頭へ戻る', () => {
    expect(nextIndexOnTap(3, 4)).toBe(0);
  });
});

describe('isTap', () => {
  it('ほとんど動いていなければタップ', () => {
    expect(isTap(100, 104)).toBe(true);
  });

  it('スワイプ（大きく動いた）はタップではない', () => {
    expect(isTap(100, 180)).toBe(false);
  });
});

describe('MainSlider', () => {
  let container;

  beforeEach(() => {
    // react-swipeable-views は初回描画で先頭スライドだけを出し、残りを setTimeout 後に描画する
    jest.useFakeTimers();
    container = document.createElement('div');
    document.body.appendChild(container);
  });

  afterEach(() => {
    ReactDOM.unmountComponentAtNode(container);
    container.remove();
    jest.useRealTimers();
  });

  const render = (props) => {
    act(() => {
      ReactDOM.render(
        <MainSlider photoUrl="main.jpg" videoIds={[]} subPhotoUrls={['sub.jpg']} {...props} />,
        container,
      );
    });
    act(() => {
      jest.runAllTimers();
    });
  };

  const activeIndex = () => {
    const slides = Array.from(container.querySelectorAll('figure'));
    return slides.findIndex((figure) => figure.parentElement.getAttribute('aria-hidden') === 'false');
  };

  const tap = (element) => {
    act(() => {
      element.dispatchEvent(new MouseEvent('pointerdown', { bubbles: true, clientX: 50 }));
      element.dispatchEvent(new MouseEvent('click', { bubbles: true, clientX: 50 }));
    });
  };

  it('サークル動画2本は写真の後ろ（末尾）にミュート自動再生の video で並ぶ', () => {
    render({ circleMovieUrls: ['https://example.com/m1.mp4', 'https://example.com/m2.mp4'] });

    const figures = Array.from(container.querySelectorAll('figure'));
    expect(figures).toHaveLength(1 + 1 + 2);
    expect(figures[0].querySelector('img').getAttribute('data-src')).toBe('main.jpg');
    expect(figures[1].querySelector('img').getAttribute('data-src')).toBe('sub.jpg');
    const videos = figures.slice(2).map((figure) => figure.querySelector('video'));
    expect(videos.map((video) => video.getAttribute('src'))).toEqual([
      'https://example.com/m1.mp4',
      'https://example.com/m2.mp4',
    ]);
    videos.forEach((video) => {
      expect(video.muted).toBe(true);
      // iOS Safari の自動再生条件。React は muted 属性を出さないため ref で付けている
      expect(video.hasAttribute('muted')).toBe(true);
      expect(video.hasAttribute('autoplay')).toBe(true);
      expect(video.hasAttribute('loop')).toBe(true);
      expect(video.hasAttribute('playsinline')).toBe(true);
    });
  });

  it('スライド本体のタップで次へ進み、最後のスライドでは先頭へ戻る', () => {
    render({ circleMovieUrls: ['https://example.com/m1.mp4'] });
    const figures = () => Array.from(container.querySelectorAll('figure'));

    expect(activeIndex()).toBe(0);
    tap(figures()[0]);
    expect(activeIndex()).toBe(1);
    tap(figures()[1]);
    expect(activeIndex()).toBe(2);
    tap(figures()[2]);
    expect(activeIndex()).toBe(0);
  });
});
